import Home from './pages/Home'

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import './App.css'

import { Amplify } from 'aws-amplify';
const amplifyconfig = require('./amplifyconfiguration.json');
Amplify.configure(amplifyconfig);

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path='/'
          element={
            <div style={{
              backgroundImage: `repeating-linear-gradient(#201825, #131117)`,//`url(${backgroundImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              imageRendering: 'crisp-edges'
            }}>
              <Home />
            </div>
          }
        />
      </Routes>
    </Router>
  )
}

export default App
